import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatProgressSpinnerModule, MatTooltipModule } from '@angular/material';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { TabServicesComponent } from './tab-services.component';

@NgModule({
  declarations: [
    TabServicesComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    TranslateModule,
    FuseSharedModule,
    ReactiveFormsModule,

    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatProgressSpinnerModule
  ],
  exports: [
    TabServicesComponent
  ]
})
export class TabServicesModule { }
